import Url from "./Url";

export default {
    install(Vue) {
        Vue.prototype.url = Url;
    }
}